export default __webpack_public_path__ + "static/media/game-on-bg.65df5918.png";